"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetProductNameToBeAssociated = exports.setOriginalAssociatedProductName = exports.setProductNameToBeAssociated = exports.associateProductToComponentsSuccess = exports.associateProductToComponentsError = exports.associateProductToComponents = exports.updateProductError = exports.updateProductSuccess = exports.updateProduct = exports.toggleComponentList = exports.closeProductToast = exports.openProductsToast = exports.onHideSavePrompt = exports.onShowSavePrompt = exports.deleteProductSuccess = exports.deleteProductError = exports.deleteProduct = exports.getProductsListError = exports.getProductsListSuccess = exports.getProductsList = exports.closeDeleteProductModal = exports.openDeleteProductModal = exports.productsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    products: [],
    originalAssociatedProductName: "",
    isProductListLoading: false,
    hasErrorLoadingProducts: false,
    isDeleteAlertDialogShown: false,
    productToBeDeleted: null,
    rowIndexToBeDeleted: 0,
    isDeleting: false,
    hasDeletionError: false,
    isSavePromptVisible: false,
    isComponentListToggled: false,
    productNameToBeAssociated: "Product Name",
    isProductCreationLoading: false,
    hasErrorCreatingProduct: false,
    productToastStatus: { isOpen: false, message: "", status: undefined },
    isCreatingAssociation: false,
    hasErrorCreatingAssociation: false,
    createAssociationSuccess: false,
};
exports.productsSlice = (0, toolkit_1.createSlice)({
    name: "products",
    initialState,
    reducers: {
        getProductsList: (state) => {
            state.isProductListLoading = true;
        },
        setOriginalAssociatedProductName: (state, action) => {
            state.originalAssociatedProductName = action.payload;
        },
        getProductsListSuccess: (state, action) => {
            state.isProductListLoading = false;
            state.hasErrorLoadingProducts = false;
            state.products = action.payload;
        },
        getProductsListError: (state) => {
            state.isProductListLoading = false;
            state.hasErrorLoadingProducts = true;
        },
        setProductNameToBeAssociated: (state, action) => {
            state.productNameToBeAssociated = action.payload;
        },
        resetProductNameToBeAssociated: (state, action) => {
            if (!action.payload) {
                state.productNameToBeAssociated = "Product Name";
                return;
            }
            state.productNameToBeAssociated = action.payload;
        },
        openDeleteProductModal: (state, action) => {
            state.isDeleteAlertDialogShown = true;
            state.productToBeDeleted = action.payload.productToBeDeleted;
            state.rowIndexToBeDeleted = action.payload.rowIndexToBeDeleted;
        },
        closeDeleteProductModal: (state) => {
            state.isDeleteAlertDialogShown = false;
            state.productToBeDeleted = null;
            state.rowIndexToBeDeleted = 0;
        },
        deleteProduct: (state) => {
            state.isDeleting = true;
        },
        deleteProductSuccess: (state) => {
            state.isDeleting = false;
            state.isDeleteAlertDialogShown = false;
            state.productToBeDeleted = null;
            state.rowIndexToBeDeleted = 0;
            state.hasDeletionError = false;
        },
        deleteProductError: (state) => {
            state.isDeleting = false;
            state.hasDeletionError = true;
        },
        onShowSavePrompt: (state) => {
            state.isSavePromptVisible = true;
        },
        onHideSavePrompt: (state) => {
            state.isSavePromptVisible = false;
        },
        openProductsToast: (state, action) => {
            state.productToastStatus.status = action.payload.status;
            state.productToastStatus.message = action.payload.message;
            state.productToastStatus.isOpen = true;
        },
        closeProductToast: (state) => {
            state.productToastStatus.isOpen = false;
            state.productToastStatus.status = undefined;
            state.productToastStatus.message = "";
        },
        toggleComponentList: (state, action) => {
            state.isComponentListToggled = action.payload;
        },
        updateProduct: (state) => {
            state.isProductCreationLoading = true;
            state.hasErrorCreatingProduct = false;
        },
        updateProductSuccess: (state) => {
            state.isProductCreationLoading = false;
        },
        updateProductError: (state) => {
            state.isProductCreationLoading = false;
            state.hasErrorCreatingProduct = true;
        },
        associateProductToComponents: (state) => {
            state.isCreatingAssociation = true;
            state.hasErrorCreatingAssociation = false;
            state.createAssociationSuccess = false;
        },
        associateProductToComponentsSuccess: (state) => {
            state.isCreatingAssociation = true;
            state.hasErrorCreatingAssociation = false;
            state.createAssociationSuccess = true;
        },
        associateProductToComponentsError: (state) => {
            state.isCreatingAssociation = false;
            state.hasErrorCreatingAssociation = true;
            state.createAssociationSuccess = false;
        },
    },
});
_a = exports.productsSlice.actions, exports.openDeleteProductModal = _a.openDeleteProductModal, exports.closeDeleteProductModal = _a.closeDeleteProductModal, exports.getProductsList = _a.getProductsList, exports.getProductsListSuccess = _a.getProductsListSuccess, exports.getProductsListError = _a.getProductsListError, exports.deleteProduct = _a.deleteProduct, exports.deleteProductError = _a.deleteProductError, exports.deleteProductSuccess = _a.deleteProductSuccess, exports.onShowSavePrompt = _a.onShowSavePrompt, exports.onHideSavePrompt = _a.onHideSavePrompt, exports.openProductsToast = _a.openProductsToast, exports.closeProductToast = _a.closeProductToast, exports.toggleComponentList = _a.toggleComponentList, exports.updateProduct = _a.updateProduct, exports.updateProductSuccess = _a.updateProductSuccess, exports.updateProductError = _a.updateProductError, exports.associateProductToComponents = _a.associateProductToComponents, exports.associateProductToComponentsError = _a.associateProductToComponentsError, exports.associateProductToComponentsSuccess = _a.associateProductToComponentsSuccess, exports.setProductNameToBeAssociated = _a.setProductNameToBeAssociated, exports.setOriginalAssociatedProductName = _a.setOriginalAssociatedProductName, exports.resetProductNameToBeAssociated = _a.resetProductNameToBeAssociated;
exports.default = exports.productsSlice.reducer;
